module.exports = __webpack_public_path__ + "static/media/Yorick_0.def06a12.jpg";